import { HorizontalBounds } from '../types';

// PrimeReact portals the column filter overlay to document.body, so no ancestor clips it to the grid.
export const getColumnFilterClipPath = (
  overlay: HorizontalBounds,
  trigger: HorizontalBounds,
  viewport: HorizontalBounds
): string => {
  // Gated on the trigger: PrimeReact clamps the overlay to the window, so it can overhang the grid while its column is still fully visible.
  const hiddenLeft: number =
    trigger.left < viewport.left
      ? Math.max(0, viewport.left - overlay.left)
      : 0;
  const hiddenRight: number =
    trigger.right > viewport.right
      ? Math.max(0, overlay.right - viewport.right)
      : 0;
  if (hiddenLeft === 0 && hiddenRight === 0) return '';

  return `inset(0 ${hiddenRight}px 0 ${hiddenLeft}px)`;
};
